<template>
  <section id="hero-static" class="hero-static d-flex">
      <div class="container d-flex" data-aos="fade-up">
        <video class='mainVideo' autoplay loop muted>
              <source :src="src" type='video/mp4'>
        </video>
      </div>
  </section>
</template>
<script src="@/assets/js/Home/MainPage.js"></script>

<style scoped>
.mainVideo{
  width: 100%;
  height: auto;
}
.container{
  margin: 0px;
  width: 100%;
  max-width: none;
  padding: 0;
  overflow: hidden;
}
</style>
